import { createApp } from 'vue'
import VueTheMask from 'vue-the-mask'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './utils/axios'
import api from './plugins/api'
import cookies from './plugins/cookies'

import './assets/scss/main.scss'

createApp(App)
  .use(router)
  .use(store)
  .use(cookies)
  .use(api, { axios })
  .use(VueTheMask)
  .mount('#app')
